import { createSlice } from "@reduxjs/toolkit";

export const applicationControlSlice = createSlice({
  name: "applicationControl",
  initialState: {
    busy: false,
  },
  reducers: {
    setApplicationBusy: (state, action) => {
      state.busy = action.payload;
    },
  },
});

export const { setApplicationBusy } = applicationControlSlice.actions;

export const isApplicationBusy = (state) => state.applicationControl.busy;

export const applicationControlReducer = applicationControlSlice.reducer;
